// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/icon.component.scss
// module id = 55
// module chunks = 0